<template>
    <flatpickr v-model="dateRange" :config="{
        mode: 'range',
        maxDate: 'today',
        onChange: onDateRangeChange
    }" placeholder="Select Date" :value="value" class="date-picker" />
</template>

<script>
import flatpickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        flatpickr
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                startDate: null,
                endDate: null
            })
        }
    },
    data() {
        return {
            dateRange: {
                startDate: null,
                endDate: null
            }
        }
    },
    methods: {
        onDateRangeChange(selectedDates, dateStr, instance) {
            if (selectedDates.length === 2) {
                const startDate = instance.formatDate(selectedDates[0], 'Y-m-d') + ' 00:00:00';
                const endDate = instance.formatDate(selectedDates[1], 'Y-m-d') + ' 23:59:59';
                this.$emit('input', { startDate, endDate });
            }
            this.dateRange.startDate = selectedDates[0];
            this.dateRange.endDate = selectedDates[1];
        }
    },
    watch: {
        value: {
            handler(newValue) {
                if (!newValue.startDate || !newValue.endDate) {
                    this.dateRange = {
                        startDate: null,
                        endDate: null
                    };
                    return;
                } 
                if (newValue.startDate.toISOString().endsWith('Z') || newValue.endDate.toISOString().endsWith('Z')) {
                    this.dateRange = {
                        startDate: null,
                        endDate: null
                    };
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
.date-picker {
    width: 100% !important;
    padding: 0.5rem 0.75rem;
    outline: none;
    border: 1px solid #ced4da;
    margin-bottom: 12px;
}
</style>